module.exports = "//static.hsappstatic.net/knowledge-content-ui/static-1.49364/img/templates/minimal.png"